<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-b-toggle.sidebar-create-additional-exam
        variant="primary"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>
    <template #cell(period)="{ data }">
      {{ getPeriod(data.value) }}
    </template>

    <template #cell(subject)="{ data }">
      {{ $langName(getAdditionalExamSubject(data.value)) }}
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'additional-exam-view', params: { id: data.item.id }})"
        />
        <feather-icon
          v-b-toggle.sidebar-create-additional-exam
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="update(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import config from './config'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  created() {
  },
  methods: {
    getAdditionalExamSubject(id) {
      return this.$store.getters['staticModule/getAdditionalExamSubject'](id)
    },
    getPeriod(id) {
      return this.$store.getters['staticModule/getPeriod'](id).admission_year
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/GET`, data)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'additionalExam'

    return {
      ...config(MODULE_NAME),
      MODULE_NAME,
    }
  },
}
</script>
